import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule} from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import {
  MatInputModule, MatButtonModule, MatSelectModule, MatCardModule,
  MatAutocompleteModule, MatIconModule, MatProgressBarModule, MatFormFieldModule
} from '@angular/material';
import { NgMatAutocompleteModule } from 'src/app/shared/components/autocomplete/autocomplete.module';
import { MaterialModule } from 'src/app/core/material';
import { HighchartsChartModule } from 'highcharts-angular';
import { EkycCameraModule } from './ekyc-camera/ekyc-camera.module';
import { DialogFailComponent } from './dialog-fail/dialog-fail.component';
import { DialogSuccessComponent } from './dialog-success/dialog-success.component';

// import {KycEnterpriseComponent} from './kyc-enterprise.component';
// import {KycConfirmAccountModule} from './kyc-confirm-account/kyc-confirm-account.module';
// import {KycSignModule} from './kyc-sign/kyc-sign.module';
// import {KycCameraModule} from './kyc-camera/kyc-camera.module';
// import {ConfirmCancelComponent} from './confirm-cancel/confirm-cancel.component';
// import {ConfirmFailComponent} from './confirm-fail/confirm-fail.component';
// import {ConfirmSuccessComponent} from './confirm-success/confirm-success.component';

@NgModule({
  declarations: [
      DialogFailComponent,
      DialogSuccessComponent
  ],
  imports: [
    MatFormFieldModule,
    CommonModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatAutocompleteModule,
    MatIconModule,
    MatProgressBarModule,
    NgMatAutocompleteModule,
    MaterialModule,
    HighchartsChartModule,
    EkycCameraModule
  ],
  entryComponents: [
  ],
  exports: [
    TranslateModule,
    EkycCameraModule
  ]
})
export class EkycModule { }
